import * as React from 'react';
import type { SVGProps } from 'react';
const SvgRectangleLandscape = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 12"
    {...props}
  >
    <path
      fill="#787887"
      d="M14.438 0c.812 0 1.5.688 1.5 1.5v9a1.5 1.5 0 0 1-1.5 1.5H1.5A1.48 1.48 0 0 1 0 10.5v-9A1.5 1.5 0 0 1 1.5 0zm-.188 10.5c.094 0 .188-.062.188-.187V1.688a.2.2 0 0 0-.188-.188H1.688c-.125 0-.188.094-.188.188v8.625q0 .187.188.187z"
    />
  </svg>
);
export default SvgRectangleLandscape;
